import { useEffect } from "react";

const siteName = "Afterparty Bot Labs";
const defaultImage = "/logo.png";

function setMeta(selector, attribute, value) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    const match = selector.match(/^meta\[([^=]+)=\"(.+)\"\]$/);
    if (match) {
      element.setAttribute(match[1], match[2]);
    }
    document.head.appendChild(element);
  }

  element.setAttribute(attribute, value);
}

export default function BotPageSeo({ bot, categories }) {
  useEffect(() => {
    const title = `${bot.name} Discord Bot | ${categories.join(", ")}`;
    const description = bot.details || bot.description;
    const url = `${window.location.origin}/bot/${bot.id}`;
    const image = `${window.location.origin}${bot.image || defaultImage}`;

    document.title = `${title} | ${siteName}`;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:image"]', "content", image);
    setMeta('meta[property="og:site_name"]', "content", siteName);
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", image);

    return () => {
      document.title = siteName;
    };
  }, [bot, categories]);

  return null;
}